export const processSteps = [
    {
      number: "01",
      title: "Discovery",
      tagline: "Understanding Your Vision",
      description: "We learn about your building's history, preservation goals, and practical requirements.",
      fullDescription: "Before we assess a single window or door, we listen. We want to understand the building—when it was constructed, how it's been used, what alterations have occurred over the decades, and what vision you have for its future. This conversation shapes everything that follows.\n\nFor general contractors, we discuss project parameters, coordination requirements, and how our scope integrates with the broader construction schedule. For institutional clients, we explore phasing options, budget cycles, and any grant or tax credit documentation requirements. For places of worship, we learn about the congregation's connection to the windows and the stories these pieces hold.",
      whatHappens: [
        "Initial phone or video consultation to discuss the project",
        "Review of available documentation (historic photos, previous reports, architectural drawings)",
        "Discussion of timeline, budget parameters, and project constraints",
        "Identification of key stakeholders and decision-makers",
        "Preliminary assessment of scope and approach"
      ],
      clientTakeaway: "A clear understanding of whether we're the right partner for your project, and a roadmap for moving forward.",
      iconName: "search" 
    },
    {
      number: "02",
      title: "Assessment",
      tagline: "Documenting Details",
      description: "Thorough evaluations with photography, measurements, and condition ratings.",
      fullDescription: "Accurate restoration begins with accurate documentation. Our assessment process captures the current condition of every window, door, and architectural element within our scope—photographing details, measuring dimensions, noting materials, and rating conditions on a standardized scale.\n\nFor stained and leaded glass, we examine lead came integrity, glass stability, paint condition, and structural support systems. For wood windows and doors, we assess joint integrity, wood deterioration, hardware function, and finish condition. For millwork and trim, we document profiles, identify missing elements, and note areas of damage or previous inappropriate repair.",
      whatHappens: [
        "On-site survey of all elements within scope",
        "Detailed photography (overview, detail, and condition documentation)",
        "Measurements and profile documentation",
        "Condition ratings using standardized assessment criteria",
        "Identification of original materials, previous repairs, and alterations",
        "Written condition report with findings and preliminary recommendations"
      ],
      clientTakeaway: "A professional condition report with photography that documents existing conditions and identifies restoration priorities.",
      iconName: "document" 
    },
    {
      number: "03",
      title: "Planning",
      tagline: "Crafting Strategy",
      description: "Detailed restoration plans with scope, schedule, and budget aligned to your needs.",
      fullDescription: "Planning is where preservation expertise meets project management. Using the assessment findings, we develop a restoration strategy that addresses every element requiring attention—prioritized by urgency, organized by phase if needed, and aligned with your schedule and budget.\n\nOur planning process considers the full picture: Which elements can be restored on-site versus those requiring workshop attention? What's the optimal sequence for removal and reinstallation? How do we coordinate with other trades on an active construction site? What documentation will be needed for historic preservation tax credits or grant validation?",
      whatHappens: [
        "Development of detailed scope of work for each element",
        "Restoration approach recommendations (preserve vs. replicate)",
        "Project schedule with key milestones",
        "Phasing options for multi-year projects",
        "Budget development with clear line items",
        "Coordination planning for general contractor integration"
      ],
      clientTakeaway: "A comprehensive proposal with scope, schedule, and budget that you can use for internal approvals, funding applications, or contractor coordination.",
      iconName: "book" 
    },
    {
      number: "04",
      title: "Craftsmanship",
      tagline: "Skill Meets Heritage",
      description: "Traditional techniques to restore, conserve, and fabricate with meticulous care.",
      fullDescription: "With planning complete and approvals in hand, the restoration begins. This is where decades of expertise, traditional techniques, and genuine care for historic materials come together.\n\nFor stained and leaded glass, our craftsmen carefully remove windows, stabilize fragile elements for transport, and bring them to our workshop for restoration. For windows, doors, and millwork, our approach emphasizes preservation of original material wherever possible.",
      whatHappens: [
        "Careful removal and protection of elements for workshop restoration",
        "Lead came replacement and structural releading for leaded glass",
        "Proper glass cleaning so as not to damage painted or etched glass",
        "Wood repair, or reconstruction",
        "Custom millwork fabrication and profile matching",
        "Quality control inspection before installation"
      ],
      clientTakeaway: "Restored elements ready for installation, with documentation of work performed and techniques used.",
      iconName: "wrench" 
    },
    {
      number: "05",
      title: "Installation",
      tagline: "Precision Placement",
      description: "Careful reinstallation with proper support and building system integration.",
      fullDescription: "Installation is more than putting pieces back in place—it's ensuring that every restored element is properly supported, protected, and integrated with the building systems around it. For stained and leaded glass, there is the option of having protective glazing systems installed that shield historic glass from weather and impact while allowing proper ventilation to prevent premature deterioration. For doors, windows, and millwork, we ensure proper fit, smooth operation, and appropriate clearances.",
      whatHappens: [
        "Coordination with other trades and project schedule",
        "Careful transport and handling of restored elements",
        "Installation of support systems and protective glazing",
        "Verification of fit, operation, and alignment",
        "Hardware installation and adjustment"
      ],
      clientTakeaway: "Restored elements installed, operational, and if needed, protected—ready to serve the building for generations to come.",
      iconName: "truck" 
    },
    {
      number: "06",
      title: "Completion",
      tagline: "Ongoing Care",
      description: "Documentation, maintenance guidance, and lasting support for future needs.",
      fullDescription: "A restoration project doesn't truly end when the last element is installed—it transitions into a new phase of stewardship. Our completion process ensures you have everything needed to protect and maintain the work we've done together.\n\nWe provide comprehensive project documentation including before, during, and after photography; detailed records of work performed; material specifications; and any relevant historical research uncovered during the project. We also provide maintenance guidance specific to your restored elements.",
      whatHappens: [
        "Final photography and documentation compilation",
        "Preparation of project closeout package",
        "Maintenance and care guidelines",
        "Staff training sessions (for institutional clients)",
        "Warranty documentation",
        "Historic preservation tax credit documentation (if applicable)"
      ],
      clientTakeaway: "A complete project record, clear maintenance guidance, and a lasting relationship with a trusted preservation partner.",
      iconName: "checkCircle" 
    }
  ];